import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveCarousel } from "../api";
import { carouselKeys } from "../queries/keys";
import type { CarouselFormValues } from "../../types";

// Create or update a carousel slide; refreshes the list afterwards.
export const useSaveCarouselMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CarouselFormValues) => saveCarousel(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: carouselKeys.all });
    },
  });
};
